// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as WishListActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import { actions as MyWishListsActions } from '../../my-wish-lists/duck';
import { actions as ScrapActions } from '../../scrap/duck';
import WishList from '../components/WishList';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    localeState: state.locale,
    localValues: state.localValues,
    isFetchingWishList: state.wishList.isFetchingWishList,
    currentWishList: state.wishList.currentWishList,
    isPostingProduct: state.wishList.isPostingProduct,
    isEditingProduct: state.wishList.isEditingProduct,
    isDeletingProduct: state.wishList.isDeletingProduct,
    isEditingLike: state.wishList.isEditingLike,
    putWishListError: state.myWishLists.putWishListError,
    isPuttingWishList: state.myWishLists.isPuttingWishList,
    putWishListSuccess: state.myWishLists.putWishListSuccess,
    deleteWishListError: state.myWishLists.deleteWishListError,
    isDeletingWishList: state.myWishLists.isDeletingWishList,
    deleteWishListSuccess: state.myWishLists.deleteWishListSuccess,
    error: state.wishList.error,
    isScrappingUrl: state.scrap.isScrappingUrl,
    scrappedProduct: state.scrap.scrappedProduct,
    scrapSuccess: state.scrap.scrapSuccess,
    scrapUrlError: state.scrap.scrapUrlError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...WishListActions,
    ...AlertActions,
    ...MyWishListsActions,
    ...ScrapActions,
    goToRedirect: (route: string) => push(route)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WishList);



// WEBPACK FOOTER //
// ./src/modules/wish-list/containers/WishListContainer.js